import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { formatGoalRewardAmount } from "@/apps/goals/utils/formatTime";
import Button from "@/ui/Button/Button";
import Modal from "@/ui/Modal/Modal";
import { GoalMultiplierMiniWheel } from "./GoalMultiplierMiniWheel";
import cls from "./styles.module.scss";

interface GoalMultiplierLockedModalProps {
  isOpen: boolean;
  onClose: () => void;
  progress: number;
  rewardAmount: number;
}

export const GoalMultiplierLockedModal = ({
  isOpen,
  onClose,
  progress,
  rewardAmount,
}: GoalMultiplierLockedModalProps) => {
  const { t } = useTranslation();
  const progressPercent = Math.min(Math.max(progress, 0), 100);
  const multipliedRewardAmount = rewardAmount * 2;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideHeader
      wrapperClassName={cls.lockedModalWrapper}
      wrapperClosingClassName={cls.lockedModalWrapperClosing}
      contentClassName={cls.lockedModalContent}
      closeAnimationMs={320}
    >
      <div className={cls.lockedSheet}>
        <h2 className={cls.lockedTitle}>
          <Trans
            i18nKey="goals.multiplier.lockedTitle"
            components={{ accent: <span className={cls.accent} /> }}
          />
        </h2>
        <p className={cls.lockedSubtitle}>
          {t("goals.multiplier.lockedSubtitle")}
        </p>

        <div className={cls.lockedProgress} aria-hidden>
          <div
            className={cls.lockedProgressFill}
            style={{ width: `${progressPercent}%` }}
          />
          <div className={cls.lockedWheel}>
            <GoalMultiplierMiniWheel />
          </div>
        </div>
        <div className={cls.lockedPill}>
          {t("goals.multiplier.multiplyBonus")}
        </div>

        <div className={cls.rewardExample}>
          <span className={cls.rewardExampleBadge}>
            {t("goals.multiplier.example")}
          </span>
          <div className={cls.rewardExampleRow}>
            <span className={cls.rewardCurrent}>
              {formatGoalRewardAmount(rewardAmount)}
            </span>
            <span className={cls.rewardMultiplier}>x2</span>
            <svg
              className={cls.rewardArrow}
              viewBox="0 0 34 16"
              aria-hidden
            >
              <path d="M2 8H30M23 2L30 8L23 14" />
            </svg>
            <strong className={cls.rewardResult}>
              {formatGoalRewardAmount(multipliedRewardAmount)}
            </strong>
          </div>
        </div>

        <Button
          className={cls.backButton}
          label={t("goals.multiplier.backToGoal")}
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};
